import React from "react";
import "./index.css";

const Container = ({ children }) => {
  return <div className="containerWidth">{children}</div>;
};

export default Container;
